module.exports = __webpack_public_path__ + "images/d57365faecf02fabe2181bfbb62ccb58-form-header.png";